import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const FilterToolbar = ({ filters, onFilterChange, notificationCounts }) => {
  const typeFilters = [
    { value: 'all', label: 'All', icon: 'List', color: 'text-foreground' },
    { value: 'goal_achievement', label: 'Achievements', icon: 'Trophy', color: 'text-success' },
    { value: 'badge_earned', label: 'Badges', icon: 'Medal', color: 'text-yellow-500' },
    { value: 'friend_milestone', label: 'Milestones', icon: 'Star', color: 'text-success' },
    { value: 'activity_milestone', label: 'Activity', icon: 'Activity', color: 'text-accent' },
    { value: 'duel_invitation', label: 'Duel Invites', icon: 'Swords', color: 'text-orange-600' },
    { value: 'duel_accepted', label: 'Duel Accepted', icon: 'CheckCircle', color: 'text-orange-500' },
    { value: 'duel_completed', label: 'Duel Results', icon: 'Flag', color: 'text-orange-400' },
    { value: 'friend_request', label: 'Friends', icon: 'UserPlus', color: 'text-primary' },
    { value: 'friend_accepted', label: 'Friend Joined', icon: 'UserCheck', color: 'text-primary' },
    { value: 'squad_invitation', label: 'Squad Invites', icon: 'Users', color: 'text-blue-600' },
    { value: 'squad_member_joined', label: 'Squad Joined', icon: 'UserPlus2', color: 'text-blue-500' },
    { value: 'challenge_invitation', label: 'Challenges', icon: 'Zap', color: 'text-purple-600' },
    { value: 'meal_reminder', label: 'Meals', icon: 'Utensils', color: 'text-warning' },
    { value: 'sleep_insight', label: 'Sleep', icon: 'Moon', color: 'text-purple-600' },
  ];

  const statusFilters = [
    { value: 'all', label: 'All' },
    { value: 'unread', label: 'Unread' },
    { value: 'read', label: 'Read' }
  ];

  const handleTypeChange = (type) => {
    onFilterChange({ ...filters, type });
  };

  const handleStatusChange = (status) => {
    onFilterChange({ ...filters, status });
  };

  return (
    <div className="mb-6 space-y-4">
      {/* Type Filters */}
      <div>
        <label className="block text-sm font-medium text-muted-foreground mb-2">Filter by Type</label>
        <div className="flex flex-wrap gap-2">
          {typeFilters?.map((filter) => {
            const count = notificationCounts?.[filter?.value] ?? 0;
            const isActive = filters?.type === filter?.value;
            // Only show filters that have items, except 'all'
            if (filter?.value !== 'all' && count === 0) return null;

            return (
              <motion.button
                key={filter?.value}
                onClick={() => handleTypeChange(filter?.value)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg border transition-all duration-200 ${
                  isActive
                    ? 'bg-primary text-primary-foreground border-primary shadow-md'
                    : 'bg-card text-foreground border-border hover:border-primary/50 hover:bg-muted'
                }`}
              >
                <Icon name={filter?.icon} size={16} className={isActive ? 'text-primary-foreground' : filter?.color} />
                <span className="text-sm font-medium">{filter?.label}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  isActive
                    ? 'bg-primary-foreground/20 text-primary-foreground'
                    : 'bg-muted text-muted-foreground'
                }`}>
                  {count}
                </span>
              </motion.button>
            );
          })}
        </div>
      </div>
      {/* Status Filters */}
      <div>
        <label className="block text-sm font-medium text-muted-foreground mb-2">Filter by Status</label>
        <div className="flex space-x-2">
          {statusFilters?.map((filter) => {
            const isActive = filters?.status === filter?.value;

            return (
              <motion.button
                key={filter?.value}
                onClick={() => handleStatusChange(filter?.value)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`px-4 py-2 rounded-lg border text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? 'bg-accent text-accent-foreground border-accent shadow-md'
                    : 'bg-card text-foreground border-border hover:border-accent/50 hover:bg-muted'
                }`}
              >
                {filter?.label}
              </motion.button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FilterToolbar;